import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImages2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconImages2"><Path d="M14.5 7C13.1193 7 12 8.11929 12 9.5C12 10.8807 13.1193 12 14.5 12C15.8807 12 17 10.8807 17 9.5C17 8.11929 15.8807 7 14.5 7Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM4.5 14.4393L8 10.9393L16.5607 19.5H19.5V4.5H4.5V14.4393Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImages2;
